import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const l = i((e, r) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: r,
    ...e,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: /* @__PURE__ */ o.jsx("rect", { width: 16, height: 16, fill: "#B9B9C5", rx: 4 })
      }
    )
  }
));
l.displayName = "PlaceholderIcon";
export {
  l as PlaceholderIcon,
  l as default
};
//# sourceMappingURL=index.js.map
